<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
  <v-btn 
    color="brand onBrand--text"
    dark
    small
    style="margin-right:0.5em;border-radius:8px;"
    @click="videoDialog = true"
  >
    <v-icon left>mdi-youtube</v-icon>
    Watch Tutorial
  </v-btn>
</div>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Course Plan Execution</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                            :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd();"
                            persistent-hint hint="Please Select Academic Year" />
                    </v-col>
                    <!-- <v-col sm="2" v-if="std_div_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required 
                    v-model="sel_std_data" return-object :items="std_div_list" 
                    item-text="std" 
                    label="Standard" 
                    outlined @change="getCourse" 
                    persistent-hint hint="Please Select Standard"
                    />
                </v-col>
                <v-col sm="2" v-if="div_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required 
                    v-model="div" item-value="id" :items="div_list" 
                    item-text="division" 
                    label="Divisions" outlined 
                    persistent-hint hint="Please Select Division"
                    />
                </v-col> -->
                    <!-- <v-col sm="2" v-if="crs_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required 
                    v-model="crs" item-value="crsid" :items="crs_list" 
                    item-text="crs_name" 
                    label="Subject" outlined 
                    persistent-hint hint="Please Select Subject"
                    />
                </v-col> -->

                    <v-col sm="2" v-if="crs != null">
                        <v-btn class="mt-6 button" @click="proceed()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box" v-if="course_plan_list.length > 0">
            <v-btn class="ma-2 no-display " rounded color="success" outlined
                @click="fnExcelReportCoursePlans('my-table-id2', 'Course Plans')" :loading="loader"><v-icon
                    color="success">mdi-export</v-icon>Export</v-btn>
            <v-expansion-panels accordion focusable>
                <v-expansion-panel>
                    <v-expansion-panel-header outlined class="subtitle-1 font-weight-medium toolbar">
                        Course Plans
                        <template v-slot:actions>
                            <v-btn fab small><v-icon color="primary">$expand</v-icon> </v-btn>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="box">
                        <v-data-table id="my-table-id2" v-if="course_plan_list.length > 0" dense :headers="headers"
                            :items="course_plan_list" class="elevation-1 mytable">
                            <template v-slot:item.file="{ item }">
                                <span v-if="item.file != null">
                                    <a class="p-2" :href="aws_path + item.file" target="blank">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                        color="black">mdi-eye</v-icon></v-btn>
                                            </template>
                                            <span>
                                                View Lesson Document File!!!
                                            </span>
                                        </v-tooltip>
                                    </a>
                                </span>
                                <span v-else>
                                    NA
                                </span>
                            </template>
                        </v-data-table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
        <v-card class="box" v-if="course_plan_list.length > 0">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Course Plan Execution</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>

                <v-row justify="center">
                    <v-col cols="3"> </v-col>
                    <v-col cols="4">
                        <p class="padding-bot"><b>Lecture No</b></p>
                        <v-text-field class="padding-bot" type="number" @change="getDetails(save_execution.lesson_no)"
                            outlined dense v-model="save_execution.lesson_no"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <p class="padding-bot"><b>Lesson Date</b></p>
                        <input type="date" placeholder="dd/mm/yyyy" name="mode_date" id="datePicker"
                            v-model="save_execution.date" dense :min="`${date_fun}`" />
                    </v-col>
                    <v-col cols="2">
                        <span v-if="save_execution.file != null">
                            <p class="padding-bot"><b>Lesson File</b></p>
                            <a class="p-2" :href="aws_path + save_execution.file" target="blank">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                color="black">mdi-eye</v-icon></v-btn>
                                    </template>
                                    <span>
                                        View Lesson Document File!!!
                                    </span>
                                </v-tooltip>
                            </a>
                        </span>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="org_id == 'sanjivani'">
                    <v-col cols="3"> </v-col>
                    <v-col cols="4">
                        <p class="padding-bot"><b>Period No</b></p>
                        <v-text-field class="padding-bot" type="number" outlined dense
                            v-model="save_execution.period_no"></v-text-field>
                    </v-col>
                    <v-col cols="5"></v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="3"> </v-col>
                    <v-col cols="4" v-if="org_id == 'wws' || org_id == 'sanjivani'">
                        <p class="padding-bot"><b>Chapter</b></p>
                        <v-text-field class="padding-bot" outlined dense
                            v-model="save_execution.chapter"></v-text-field>
                    </v-col>
                    <v-col cols="4" v-else>
                        <p class="padding-bot"><b>Chapter</b></p>
                        <v-text-field class="padding-bot" outlined dense
                            v-model="save_execution.chapter"></v-text-field>
                    </v-col>
                    <v-col cols="5"></v-col>
                </v-row>


                <v-row justify="center">
                    <v-col cols="3"> </v-col>
                    <v-col cols="4">
                        <p class="padding-bot"><b>Concept/Skills/Topic Covered</b></p>
                        <v-textarea class="padding-bot" outlined dense v-model="save_execution.topics_covered">
                        </v-textarea>
                    </v-col>

                    <!-- <v-col cols="1">
                        <p class="padding-bot"></p>
                        <br />
                        <v-icon @click="addmore()"> mdi-plus</v-icon>
                    </v-col> -->
                    <v-col cols="5"></v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="2"> </v-col>
                    <v-col cols="4">

                        <p class="padding-bot"><b>Home Work</b></p>
                        <v-text-field class="padding-bot" outlined dense v-model="save_execution.home_work">
                        </v-text-field>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="2"> </v-col>
                    <v-col cols="4">
                        <p class="padding-bot"><b>Remark</b></p>
                        <v-text-field class="padding-bot" outlined dense v-model="save_execution.remark">
                        </v-text-field>
                    </v-col>
                    <v-col cols="4"></v-col>
                </v-row>

                <!-- <v-row justify="center">
                    <v-col cols="3"> </v-col>
                    <v-col cols="4">
                        <v-simple-table v-if="this.save_execution.topics_covered.length > 0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Sr No.</th>
                                        <th class="text-left">Topic</th>
                                        <th class="text-left">Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in save_execution.topics_covered" :key="item">
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ item }}</td>
                                        <td><v-icon @click="removeFromTopics(i)"> mdi-trash-can</v-icon></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="5"></v-col>
                </v-row> -->
                <v-row justify="center">
                    <v-btn class="mt-6 button" :disabled="!is_plan_data_available" @click="save()">Save</v-btn>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box" v-if="this.crs_list.length > 0">
            <v-btn class="ma-2 no-display " rounded color="success" outlined
                @click="fnExcelReportCourseDetails('my-table-id', 'Course Details')" :loading="loader"><v-icon
                    color="success">mdi-export</v-icon>Export</v-btn>
            <v-data-table id="my-table-id" :headers="computedHeadersCourse" dense class="elevation-1" :items="crs_list">
                <template v-slot:top>
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title> Course Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.proceed`]="{ item }">
                    <div>
                        <v-btn color="warning" rounded dense @click="proceed(item)">Proceed</v-btn>
                    </div>
                </template>
                <template v-slot:[`item.grl_mapping_file`]="{ item }">
                    <span v-if="item.grl_mapping_file != null">
                        <a :href="item.grl_mapping_file" target="_blank">
                            <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
                        </a>
                    </span>
                    <span v-else>--</span>
                </template>
                <template v-slot:[`item.vertical_mapping_file`]="{ item }">
                    <span v-if="item.vertical_mapping_file != null">
                        <a :href="item.vertical_mapping_file" target="_blank">
                            <v-icon class="mr-2 v-icon-size" color="primary">mdi-eye</v-icon>
                        </a>
                    </span>
                </template>
            </v-data-table>
        </v-card>

        <v-card class="box" v-if="course_plan_execution_list.length > 0">
            <v-btn class="ma-2 no-display " rounded color="success" outlined
                @click="fnExcelReportCoursePlanExecutionDetails('my-table-id1', 'Course Plan Execution Details')"
                :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
            <template v-if="course_plan_execution_list.length > 0">
                <v-data-table id="my-table-id1" :headers="displayedHeaders" :items="course_plan_execution_list"
                    class="elevation-1 mytable" :search="search" dense>
                    <template v-slot:top>
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>Course Plan Execution Details</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <div>
                            <v-avatar size="25" class="edit-avatar">
                                <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                </v-data-table>
            </template>
        </v-card>

        <v-dialog v-model="this.dialog_addtopic" persistent max-width="600px">
            <v-card>
                <!-- {{topics_covered}} -->
                <v-container>
                    <v-btn class="button" outlined @click="dialog_addtopic = false">Close</v-btn>
                    <v-card class="box">
                        <v-row dense justify="center">
                            <v-col cols="7">
                                <p class="padding-bot"><b>Add Topic</b></p>
                                <v-text-field class="padding-bot" outlined dense v-model="topics"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense justify="center">
                            <v-btn class="mt-6 button" @click="add()">Add</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_edit" max-width="1100px" v-if="dialog_edit == true">
            <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Edit Execution
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="2">
                            <p><b>Lecture No</b></p>
                            <v-text-field outlined dense type="text" v-model="edit_item.lecture_no"
                                readonly></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" v-if="org_id == 'sanjivani'">
                            <p><b>Period No</b></p>
                            <v-text-field outlined dense type="text" v-model="edit_item.period_no"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <p><b>Chapter</b></p>
                            <v-text-field outlined dense type="text" v-model="edit_item.unit"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="5">
                            <p><b>Topic</b></p>
                            <v-text-field outlined dense type="text" v-model="edit_item.topic"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <p><b>Execution Date</b></p>
                            <input type="date" v-model="edit_item.execution_date" />
                        </v-col>
                    </v-row>

                    <v-row justify="center" dense>
                        <v-col cols="12" sm="5">
                            <p><b>Homework</b></p>
                            <v-text-field outlined dense type="text" v-model="edit_item.homework"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <p><b>Remark</b></p>
                            <v-text-field outlined dense type="text" v-model="edit_item.remark"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row justify="center" dense>
                        <v-col cols="12" sm="2">
                            <p></p>
                            <v-btn class="button" :loading="edit_loader" @click="saveUpdate()">Update</v-btn>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Lesson Planning & Execution Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/2AnofIWgp_A?si=GtYtP6GrcKQ8cnX4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        course_off_inst: "",
       videoDialog: false, 
        topics: "",
        dialog_addtopic: false,
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        dialog_edit: false,
        save_execution: {
            lesson_no: "",
            date: "",
            remark: "",
            home_work: "",
            chapter: "",
            topics_covered: "",
            file: null,
            period_no:null,
        },
        topics: "",

        search: "",
        headers_course: [
            { text: "Sr. No.", value: "srno" },
            { text: "Course", value: "course" },
            { text: "Standard", value: "standard" },
            { text: "Division", value: "division" },
            { text: "GRL Mapping", value: "grl_mapping_file" },
            { text: "Vertical Mapping", value: "vertical_mapping_file" },
            { text: "Proceed", value: "proceed", sortable: false },
        ],
        headers_1: [
            // { text: "Sr. No.", value: "srno" },
            { text: "Lecture No", value: "lecture_no" },
            { text: "Unit", value: "unit" },
            { text: "Standard", value: "standard" },
            { text: "Division", value: "division" },
            { text: "Course", value: "course" },
            { text: "Topics Covered", value: "topic" },
            { text: "Homework", value: "homework" },
            { text: "Remark", value: "remark" },
            { text: "Execution Date", value: "execution_date" },
            { text: "Edit", value: "edit", sortable: false },
        ],
        headers: [
            { text: "Sr. No.", value: "sr_no" },
            { text: "Lecture No", value: "lecture_no" },
            { text: "Chapter", value: "unit" },
            { text: "Concept & Skills / Topic", value: "topic" },
            { text: "Learning Outcomes", value: "learning_outcomes" },
            { text: "Instructional Tools & Reference", value: "instructional_tool_refernences" },
            { text: "Pedagogy", value: "pedagogy" },
            { text: " Activity / Assignment / Research", value: "activity_assignment_research" },
            { text: "Assessment", value: "assessment" },
            { text: "Examination", value: "exam_name" },
            { text: "File", value: "file" },
        ],
        snackbar_msg: "",
        color: "",
        snackbar: false,
        loader: false,
        ay_std_div_list: null,
        sel_ay_data: null,
        std_div_list: null,
        sel_std_data: null,
        div_list: null,
        aws_path: null,
        div: null,
        crs_list: [],
        crs: null,
        course_plan_list: [],
        plan_details: [],
        course_plan_execution_list: [],
        edit_item: {
            id: "",
            topic: "",
            unit: "",
            lecture_no: "",
            execution_date: "",
            period_no:null,
            homework:null,
            remark:null,
        },
        edit_loader: false, org_id: null,is_plan_data_available:false,
    }),
    computed: {
        date_fun: () => {
            $(document).ready(function () {
                var now = new Date();
                var month = now.getMonth() + 1;
                var day = now.getDate();
                if (month < 10) month = "0" + month;
                if (day < 10) day = "0" + day;
                var today = now.getFullYear() + "-" + month + "-" + day;
                $("#datePicker").val(today);
            });
        },
        computedHeadersCourse(){
            if (this.org_id == 'wws')
            {
                return this.headers_course.filter (header =>
                    header.value !== 'grl_mapping_file' && header.value !== 'vertical_mapping_file'                
                );
            }
            return this.headers_course;
        },
         displayedHeaders() {
        // Add "Period" header conditionally
            return this.org_id=='sanjivani'
                ? [{ text: "Period No", value: "period_no" }, ...this.headers_1]
                : this.headers_1;
    }
    },
    methods: {
        // removeFromTopics(indexToRemove){
        //     this.save_execution.topics_covered.splice(indexToRemove, 1);
        // },
        fnExcelReportCourseDetails(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
                <th>Sr.No</th>
                <th>Course</th>
                <th>Standard</th>
                <th>Division</th>
            </tr>`;

            this.crs_list.forEach((s, index) => {
                tab_text += `
             <tr>
                <td>${s.srno}</td>
                <td>${s.course}</td>
                <td>${s.standard}</td>
                <td>${s.division}</td>
            </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        fnExcelReportCoursePlanExecutionDetails(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
                <th>Sr.No.</th>
                <th>Lecture No</th>
                <th>Unit</th>
                <th>Topics Covered</th>
                <th>Execution Date</th>
            </tr>`;

            this.course_plan_execution_list.forEach((s, index) => {
                tab_text += `
             <tr>
                <td>${s.srno}</td>
                <td>${s.lecture_no}</td>
                <td>${s.unit}</td>
                <td>${s.topic}</td>
                <td>${s.execution_date}</td>
            </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        fnExcelReportCoursePlans(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
                <th>Sr.No</th>
                <th>Lecture No</th>
                <th>Chapter</th>
                <th>Concept & Skills / Topic</th>
                <th>Learning Outcomes</th>
                <th>Instructional Tools & Reference</th>
                <th>Pedagogy</th>
                <th>Activity /Assessment/ Research</th>
                <th>Assessment</th>
                <th>Examination</th>
                <th>File</th>
            </tr>`;

            this.course_plan_list.forEach((s, index) => {
                tab_text += `
             <tr>
                <td>${s.sr_no}</td>
                <td>${s.lecture_no}</td>
                <td>${s.unit}</td>
                <td>${s.topic}</td>
                <td>${s.learning_outcomes}</td>
                <td>${s.instructional_tool_refernences}</td>
                <td>${s.pedagogy}</td>
                <td>${s.activity_assignment_research}</td>
                <td>${s.assessment}</td>
                <td>${s.exam_name}</td>
                <td>${s.file}</td>
            </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },

        saveUpdate() {
            this.edit_loader = true;
            axios
                .post("/LessonPlanExecution/saveUpdateExecutionPlan", this.edit_item)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.showSnackbar("#4caf50", "Execution Updated Successfully...!");
                        this.edit_loader = false;
                        this.dialog_edit = false;
                        this.course_plan_execution_list = res.data.course_plan_execution_list;
                    } else {
                        //   window.console.log(res.data.msg);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        this.edit_loader = false;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.edit_loader = false;
                });
        },
        editItem(item) {
            this.dialog_edit = true;
            this.edit_item.id = item.id;
            this.edit_item.topic = item.topic;
            this.edit_item.unit = item.unit;
            this.edit_item.lecture_no = item.lecture_no;
            this.edit_item.period_no = item.period_no;
            this.edit_item.execution_date = item.execution_date_edit;
            this.edit_item.homework = item.homework;
            this.edit_item.remark = item.remark;
        },
        reset() {
            (this.save_execution = ""),
                (this.course_plan_list = []),
                (this.plan_details = [].this.ay_std_div_list = null),
                (this.sel_ay_data = null),
                (this.std_div_list = null),
                (this.sel_std_data = null),
                (this.div_list = null),
                (this.div = null),
                (this.crs_list = []),
                (this.crs = null);
        },
        emptySaveExecution(){
            this.save_execution.chapter=""
            this.save_execution.lesson_no=""
            this.save_execution.date=""
            this.save_execution.remark=""
            this.save_execution.home_work=""
            this.save_execution.topics_covered=""
            this.save_execution.file=null
            this.topics=""
        },
        getDetails(item) {
            // alert("item::"+item)
         // this.save_execution.topics_covered=[]
            const formData = {
                lesson_no: item,
                course_off_inst: this.course_off_inst,
                ay: this.sel_ay_data.ay_id,
            };
            axios
                .post("/LessonPlanExecution/getDetails", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.plan_details = res.data.plan_details;
                        this.save_execution.chapter = res.data.plan_details[0].unit || res.data.plan_details[0].chapter;
                        this.save_execution.file = res.data.plan_details[0].file;
                        this.save_execution.topics_covered = res.data.plan_details[0].topic;
                        this.is_plan_data_available=true
                       // this.initPush(this.topics)
                    } else if (res.data.flag == "No") {
                        (this.save_execution.chapter = ""),
                        // (this.save_execution.topics_covered = ""),
                          (this.topics = "");
                        (this.save_execution.date = ""), this.showSnackbar("#b71c1c", res.data.snackbar);
                         this.is_plan_data_available=false
                        return;
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
        // initPush(topics){
        //     this.save_execution.topics_covered.push(topics);
        // },
        save() {
            if (this.save_execution.date == "" || this.save_execution.date == null) {
                this.showSnackbar("#b71c1c", "Please Select Date...");
                return;
            }
            const formData = {
                course_off_inst: this.course_off_inst,
                ay: this.sel_ay_data.ay_id,
                plan_details: this.save_execution,
            };
            axios
                .post("/LessonPlanExecution/saveCpursePlanExecution", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4CAF50", res.data.snackbar);
                        this.course_plan_execution_list = res.data.course_plan_execution_list;
                        // this.reset();
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                   this.emptySaveExecution()
                });
        },
        add() {
            alert("topics--->"+this.topics)
            this.topics_covered.push(this.topics);
            this.topics = "";
            return;
        },
        // addmore() {
        //     // alert("topics--->"+this.topics)
        //    // if(!this.save_execution.contains(this.topics)){
        //         this.save_execution.topics_covered.push(this.topics);
        //         this.topics = "";
        //     return;
        //    // }
        //     // this.dialog_addtopic=true
        // },
        proceed(item) {
            this.course_off_inst = item.id;
            this.course_plan_execution_list=[], this.course_plan_list=[];
           const formData = {
                ay: this.sel_ay_data.ay_id,
                course_off: item.id,
            };
            axios
                .post("/LessonPlanExecution/getCoursePlanData", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.course_plan_list = res.data.course_plan_list;
                        if (res.data.course_plan_execution_list) {
                            this.course_plan_execution_list = res.data.course_plan_execution_list;
                        }
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
        getStd() {
            (this.crs_list = []), (this.course_plan_execution_list = []), (this.course_plan_list = []);
            const data = {
                academicYear: this.sel_ay_data.ay_id,
            };
            this.overlay = true;
            axios
                .post("/LessonPlanning/getInstructorCourses", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.crs_list = res.data.course_list;
                        // this.showSnackbar("green", res.data.snackbar);
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
            // this.std_div_list = null;
            // this.sel_std_data = null;
            // this.div_list = null;
            // this.div = null;
            // this.std_div_list = this.sel_ay_data.std_list;
        },
        getCourse() {
            const formData = {
                standard: this.sel_std_data.std_id,
                ay: this.sel_ay_data.ay_id,
            };
            axios
                .post("/LessonPlanning/getCourse", formData)
                .then((res) => {
                    this.crs_list = res.data.crs_list;
                    this.div_list = res.data.division_list;
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.sel_ay_data = res.data.curr_ay;
                    this.aws_path = res.data.aws_path;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onload();
        this.org_id = localStorage.getItem("EPS-tenant");
    },
    watch: {},
};
</script>
<style scoped>
@media all and (max-width: 900px) {
    .padding-bot {
        padding: 8px;
    }
}
</style>
